import { api } from "./api";
import { ensureStripeCustomer } from "./stripeCustomer";

// Opens the Stripe-hosted Customer Portal in the same tab.
// Backend: POST /create-billing-portal-session { customerId, returnUrl }
//   Server-side: stripe.billingPortal.sessions.create({ customer, return_url }) → { url }
export const openCustomerPortal = async ({ user, profile }) => {
  const customerId = await ensureStripeCustomer({ user, profile });
  const { data } = await api.post("/create-billing-portal-session", {
    customerId,
    returnUrl: window.location.href,
  });
  const url = data?.url || data?.sessionUrl;
  if (!url) throw new Error("Backend did not return a portal URL");
  window.location.href = url;
};

// Creates a Stripe-hosted Checkout Session for a subscription and returns
// the session URL so the caller can open/copy it.
// Backend: POST /create-subscription-checkout-session
//   { customerId, priceId, userId, successUrl, cancelUrl }
//   Server-side: stripe.checkout.sessions.create({
//     mode: "subscription",
//     customer, line_items: [{ price, quantity: 1 }],
//     success_url, cancel_url,
//     subscription_data: { billing_mode: { type: "flexible" }, metadata: { userId, projectId } }
//   })
export const createSubscriptionCheckoutSession = async ({
  user,
  profile,
  priceId,
  projectId,
  successUrl,
  cancelUrl,
}) => {
  const customerId = await ensureStripeCustomer({ user, profile });
  const { data } = await api.post("/create-subscription-checkout-session", {
    customerId,
    priceId,
    userId: user?.uid || profile?.id,
    projectId,
    successUrl: successUrl || `${window.location.origin}/admin/projects`,
    cancelUrl: cancelUrl || window.location.href,
  });
  const url = data?.url || data?.sessionUrl;
  if (!url) throw new Error("Backend did not return a Checkout session URL");
  return { url, sessionId: data?.sessionId || data?.id };
};
